import React, { useEffect, useState } from "react";
import {useNavigate, useParams} from "react-router-dom";
import { useAuth } from "../AuthContext";
import DataCard from "../components/DataCard";
import {
    addCardToOffer,
    deleteOffer,
    fetchCardsForOffer,
    fetchOffer,
    fetchOffers,
    removeCardFromOffer,
    updateOffer
} from "../api/offerapi";
import DataTable from "../components/DataTable";
import CustomModal from "../components/CustomModal";
import {fetchCards} from "../api/cardapi";

export default function Offer() {
    const { id } = useParams();
    const { token } = useAuth();
    const [offer, setOffer] = useState(null);
    const [cards, setCards] = useState([])
    const [showAddCard, setShowAddCard] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate()

    const fetchData = async () => {
        setLoading(true);
        fetchOffer(id).then((r)=>{
            console.log(r.data)
            if(r.success)setOffer(r.data);
        })
        setLoading(false)
    };

    const fetchOfferCards = async () => {
        fetchCardsForOffer(id).then((r)=>setCards(r.data ?? []))
    }

    useEffect(() => {
        fetchData();
        fetchOfferCards()
    }, [id, token]);

    if (loading) return <p className="m-3">Loading offer...</p>;
    if (error) return <p className="m-3 text-danger">❌ {error}</p>;
    if (!offer) return <p className="m-3">No offer found.</p>;

    const handleOfferChange = (key, value) => {
        setOffer((prev) => ({
            ...prev,
            [key]: value
        }));
    };

    function handleSave(){
        updateOffer(offer).then(fetchData)
    }

    function handleRemoveOffer() {
        deleteOffer(id)
            .then(() => {
                // If there’s a valid history entry within the same origin
                if (window.history.length > 1) {
                    navigate(-1);
                } else {
                    navigate("/offers");
                }
            })
            .catch((err) => console.error("Failed to delete offer:", err));
    }

    function handleAddToCard(card){
        addCardToOffer(id,card.CardID ).then(fetchOfferCards)
    }
    function handleRemoveCard(card){
        removeCardFromOffer(id, card.CardID).then(fetchOfferCards)
    }

    return (
        <div className="container mt-4">

            {/* Offer Info */}
            <DataCard
                onSave={handleSave}
                title="Offer details"
                onRemove={handleRemoveOffer}
                items={[
                    { key: "Text", label: "Title", value: offer.Text, editable: true },
                    { key: "Description", label: "Description", value: offer.Description, editable: true },
                    {key: "Terms", label: "Terms", value: offer.Terms, editable: true },
                    { key: "expires_at", label: "Expires", value: new Date(offer.expires_at).toLocaleDateString(), editable: true, format:{type: "date"} },
                    { key: "created_at", label: "Created", value: offer.created_at },
                    { key: "updated_at", label: "Updated", value: offer.updated_at },
                ]}

                onChange={handleOfferChange}
                remove
            >
                <div className="pt-3">
                    <h5 className="card-title">
                        Active Days
                        <button
                            className="btn btn-outline-dark ms-2"
                            onClick={() => {
                                setOffer((prev) => ({
                                    ...prev,
                                    Days: Object.fromEntries(
                                        Object.keys(prev.Days).map((day) => [day, true])
                                    ),
                                }));
                            }}
                        >
                            All days
                        </button>
                    </h5>

                    <table className="table table-bordered text-center mb-0">
                        <thead className="table-light">
                        <tr>
                            {Object.keys(offer.Days).map((day) => (
                                <th key={day}>{day}</th>
                            ))}
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            {Object.entries(offer.Days).map(([day, active]) => (
                                <td key={day}>
                                    <button className={`btn btn-${active ? "success" : "danger"}`} onClick={() => {
                                        setOffer((prev) => ({
                                            ...prev,
                                            Days: {
                                                ...prev.Days,
                                                [day]: !active,
                                            },
                                        }));
                                    }}
                                    >{active ? "Yes" : "No"}</button>
                                </td>
                            ))}
                        </tr>
                        </tbody>
                    </table>
                </div>
            </DataCard>

            <DataTable
                title="Cards"
                columns={[
                    {key: "Name", label: "Name", searchable: true},
                    {key: "Description", label: "Description"},
                    {key: "expires_at", label: "Expires"},
                    { key: "isPublic", label: "Public", filterable: true },
                    { key: "isSharable", label: "Sharable", filterable: true },
                ]}
                data={cards.map((c) => ({
                    ...c,
                    isPublic: c.isPublic ? "Yes" : "No",
                    isSharable: c.isSharable ? "Yes" : "No",
                    expires_at: c.expires_at
                        ? new Date(c.expires_at).toLocaleDateString()
                        : "—",
                }))}
                add
                remove
                onAdd={()=>{setShowAddCard(true)}}
                onRemove={handleRemoveCard}
                onRowClick={(card)=>{navigate("/cards/"+card.CardID)}}
            />
            <AddCardModal handleAdd={handleAddToCard} show={showAddCard} onClose={()=>{setShowAddCard(false)}}/>
        </div>
    );
}

function AddCardModal({show, onClose, handleAdd}){
    const [cards, setCards] = useState([])

    useEffect(() => {
        if(show){
            fetchCards().then((r)=>{
                console.log(r)
                setCards(r.data ?? [])})
        }
    }, [show]);

    const handleRowClick = (row) => {
        handleAdd(row)
        onClose()
    }

    return <CustomModal title={"Add offer to card"} show={show} id="addOfferModal" onClose={onClose}>
        <DataTable
            title="Available cards"
            columns={[
                { key: "Name", label: "Kort", searchable: true },

            ]}
            data={cards}
            onRowClick={handleRowClick}
        />
    </CustomModal>
}
